import { darken } from '@material-ui/core/styles';

const globalStyles = {
  scrollbar: theme => ({
    '&::-webkit-scrollbar': {
      width: theme.spacing(1),
      '&-track': {
        backgroundColor: theme.palette.custom.surface[2],
      },
      '&-thumb': {
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
          backgroundColor: darken(theme.palette.primary.main, 0.1),
        },
      },
    },
  }),
};

export default globalStyles;
